// Environment configuration for Supabase
// Using hardcoded values as VITE_* env variables are not supported in Lovable
export const getSupabaseUrl = (): string => {
  return 'https://hvienkhnfdezsbadavpb.supabase.co';
};

export const getSupabaseAnonKey = (): string => {
  return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh2aWVua2huZmRlenNiYWRhdnBiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcxNjA2NzUsImV4cCI6MjA1MjczNjY3NX0.Xue_VMa_gtai8TUO6oAeIj5FMQYNBTg_RpcsJ-A78is';
};

export const getSiteUrl = (): string => {
  return window.location.origin;
};
